import rightArrow from './images/RightNarrow.svg'
import bottomArrow from './images/BottomNarrow.svg'

export const INFO = {
    rightArrow,
    bottomArrow,
}
